import { DateTime } from 'luxon';

import { getTodayDateTime } from 'forms/validators';

import { UpdateOccupationInput } from '../../../types/graph';
import { OccupationFormValues } from '../form/types';

const encodeISODate = (year?: number) => (year ? DateTime.utc(year).toISO() : null);

const buildInput = (values: OccupationFormValues): UpdateOccupationInput => {
  const input: UpdateOccupationInput = {
    atLeast30HoursAWeek: values.atLeast30HoursAWeek,
    disabilityInsuranceStatus: values.disabilityInsuranceStatus,
    educationLevel: values.educationLevel,
    governmentEmployee: values.governmentEmployee,
    individualIncome: values.individualIncome,
    jobTitleId: parseInt(values.job.value, 10),
    selfEmployed: values.selfEmployed,
    workFromHomePercentage: values.workFromHomePercentage,
    yearsOfExperience: values.yearsOfExperience,
  };

  if (values.selfEmployed) {
    input.corporateStructure = values.corporateStructure;
    input.ownershipStake = values.ownershipStake;
    input.numberOfEmployees = values.numberOfEmployees;
    input.numberOfPartners = values.numberOfPartners;
    input.companyFoundedAt = encodeISODate(values.companyFoundedAt);
    input.becameOwnerAt = encodeISODate(values.becameOwnerAt);

    if (values.companyFoundedAt && values.companyFoundedAt >= getTodayDateTime().year - 1) {
      input.annualIncomeBeforeCompany = values.annualIncomeBeforeCompany;
    }
  }

  if (values.disabilityInsuranceStatus) {
    input.existingCoverage = values.existingCoverage;
    input.disabilityInsuranceSource = values.disabilityInsuranceSource;
    input.intendToReplace = values.intendToReplace;

    if (values.disabilityInsuranceSource === 'employer') {
      input.employerPaysPremium = values.employerPaysPremium;
    }
  }

  return input;
};

export default buildInput;
